import React from 'react';
import { formatDate, formatTargetAudience, formatPlatform } from '../utils/formatters';
import { StatusBadge, UrgencyBadge } from './Badge';
import { EditIcon, TrashIcon } from './Icons';

export const NotificationTable = ({
  notifications,
  onRowClick,
  onEdit,
  onDelete,
  getAudienceLabel,
}) => (
  <div className="overflow-x-auto">
    <table className="w-full border-collapse min-w-[900px]">
      <thead>
        <tr>
          {[
            "Notification",
            "Status",
            "Urgency",
            "Recipient(s)",
            "Platforms",
            "Created By",
            "Created",
            "Scheduled",
            "Expires",
            "",
          ].map((header) => (
            <th key={header} className="text-left px-4 py-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wide bg-slate-50 border-b border-slate-200/50 whitespace-nowrap">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {notifications.map((notification) => (
          <tr
            key={notification.id}
            className="hover:bg-slate-50 cursor-pointer transition-colors"
            onClick={() => onRowClick(notification)}
          >
            <td className="px-4 py-3.5 border-b border-slate-200/50">
              <div className="font-medium text-slate-800 mb-0.5">{notification.title}</div>
              <div className="text-sm text-slate-500 max-w-[300px] truncate">{notification.notificationMessage}</div>
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50">
              <StatusBadge status={notification.status} />
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50">
              <UrgencyBadge urgency={notification.urgency} />
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50 text-sm text-slate-500">
              {getAudienceLabel
                ? getAudienceLabel(notification.targetAudience)
                : formatTargetAudience(notification.targetAudience)}
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50">
              <div className="flex gap-1 flex-wrap">
                {notification.platforms.length > 0 ? (
                  notification.platforms.map((platform) => (
                    <span key={platform} className="px-2 py-0.5 bg-slate-100 rounded text-[11px] text-slate-500 font-mono">
                      {formatPlatform(platform)}
                    </span>
                  ))
                ) : (
                  <span className="px-2 py-0.5 bg-slate-100 rounded text-[11px] text-slate-500">—</span>
                )}
              </div>
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50 text-sm text-slate-500">
              {notification.createdBy || "—"}
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50 text-sm text-slate-500">
              {formatDate(notification.createdAt)}
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50 text-sm text-slate-500">
              {formatDate(notification.scheduledSendTime)}
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50 text-sm text-slate-500">
              {formatDate(notification.expiryTime)}
            </td>
            <td className="px-4 py-3.5 border-b border-slate-200/50">
              <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
                <button
                  className="w-8 h-8 inline-flex items-center justify-center border-none bg-transparent 
                    text-slate-400 rounded-md cursor-pointer transition-all hover:bg-slate-100 hover:text-slate-700"
                  onClick={() => onEdit(notification)}
                  title="Edit"
                >
                  <EditIcon />
                </button>
                <button
                  className="w-8 h-8 inline-flex items-center justify-center border-none bg-transparent 
                    text-slate-400 rounded-md cursor-pointer transition-all hover:bg-red-50 hover:text-red-500"
                  onClick={() => onDelete(notification)}
                  title="Delete"
                >
                  <TrashIcon />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
